import { createApp } from 'vue'
import FormInputCombobox from './FormInputCombobox'

const el = '.kb-component--form-input-combobox'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((FormInputComboboxDOM) => {
            if (FormInputComboboxDOM.hasAttribute('data-v-app')) return
            const props = {
                fieldId:        FormInputComboboxDOM.dataset.fieldid,
                ariaLabel:      FormInputComboboxDOM.dataset.arialabel,
                placeholder:    FormInputComboboxDOM.dataset.placeholder,
                buttonLabel:    FormInputComboboxDOM.dataset.buttonlabel,
                noResultsLabel: FormInputComboboxDOM.dataset.noresultslabel,
                options:        JSON.parse(FormInputComboboxDOM.dataset.options || '[]')
            }
            const component = createApp(FormInputCombobox, props).use(Store)
            component.mount(FormInputComboboxDOM)
        })
    }
}
